export const CREATE_GENERAL_PURCHASE_BILL = 'CREATE_GENERAL_PURCHASE_BILL';
export const GET_GENERAL_PURCHASE_BILLS = 'GET_GENERAL_PURCHASE_BILLS';
export const GET_GENERAL_PURCHASE_BILLS_PAGE = 'GET_GENERAL_PURCHASE_BILLS_PAGE';
export const GENERAL_PURCHASE_BILL_REQUEST = 'GENERAL_PURCHASE_BILL_REQUEST';
export const UPDATE_GENERAL_PURCHASE_BILL = 'UPDATE_GENERAL_PURCHASE_BILL';
export const DELETE_GENERAL_PURCHASE_BILL = 'DELETE_GENERAL_PURCHASE_BILL';
export const GENERAL_PURCHASE_BILL_REQUEST_SUCCESS = 'GENERAL_PURCHASE_BILL_REQUEST_SUCCESS';
export const GENERAL_PURCHASE_BILL_REQUEST_FAILURE = 'GENERAL_PURCHASE_BILL_REQUEST_FAILURE';